import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-3a27c7ef"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "nerv-section hero" }
const _hoisted_2 = { class: "nerv-bezel" }
const _hoisted_3 = { class: "nerv-screen" }
const _hoisted_4 = { class: "hero-grid" }
const _hoisted_5 = { class: "hero-main" }
const _hoisted_6 = { class: "hero-mark" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "nerv-heading nerv-heading-lg hero-headline" }, " Production LLM and agent systems, built end to end ", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "nerv-lede hero-lede" }, " Eleven years shipping multi-tenant platforms across .NET, TypeScript and Go, now pointed at applied AI. ", -1))
const _hoisted_9 = { class: "hero-actions" }
const _hoisted_10 = { class: "operator" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "nerv-data-label" }, "Operator", -1))
const _hoisted_12 = { class: "nerv-datarow-key" }
const _hoisted_13 = { class: "nerv-datarow-value" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "nerv-status nerv-lcd operator-status" }, "Available for engagements", -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "hero-strip" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "nerv-caption" }, "Remote and on-site"),
  /*#__PURE__*/_createElementVNode("span", { class: "nerv-caption" }, "1099 through Dev1 Consulting LLC"),
  /*#__PURE__*/_createElementVNode("span", { class: "nerv-caption" }, "Texas LLC, active and in good standing")
], -1))
const _hoisted_16 = { class: "hero-readouts" }
const _hoisted_17 = /*#__PURE__*/_createStaticVNode("<section class=\"nerv-section\" data-v-3a27c7ef><span class=\"nerv-section-label\" data-v-3a27c7ef>Sec 01.1 // About</span><div class=\"nerv-panel nerv-bracket section-body\" data-v-3a27c7ef><h2 class=\"nerv-heading nerv-heading-lg\" data-v-3a27c7ef>About me</h2><p class=\"nerv-body\" data-v-3a27c7ef> I build AI systems that survive contact with production. That means the parts most demos skip: tool calling that respects who the user is, evals that catch regressions before customers do, and multi-tenant boundaries that hold. Eleven years in fintech and enterprise platforms taught me that the hard part is rarely the model. </p><p class=\"nerv-body\" data-v-3a27c7ef> I work through Dev1 Consulting, my own LLC, either building the product or standing up an AI initiative inside a team that has not run one before. </p></div></section>", 1)
const _hoisted_18 = { class: "nerv-section" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "nerv-section-label" }, "Sec 01.2 // Capability", -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "nerv-heading nerv-heading-lg section-title" }, "How I can help", -1))
const _hoisted_21 = { class: "nerv-grid nerv-grid-3" }
const _hoisted_22 = { class: "nerv-data-label" }
const _hoisted_23 = { class: "nerv-heading nerv-heading-md" }
const _hoisted_24 = { class: "nerv-body-sm" }
const _hoisted_25 = { class: "nerv-section" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "nerv-section-label" }, "Sec 01.3 // Tooling", -1))
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "nerv-heading nerv-heading-lg section-title" }, "Tools I work with", -1))
const _hoisted_28 = { class: "chips" }
const _hoisted_29 = { class: "nerv-section" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "nerv-section-label" }, "Sec 01.4 // Record", -1))
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "nerv-heading nerv-heading-lg section-title" }, "Selected work", -1))
const _hoisted_32 = { class: "nerv-grid nerv-grid-3" }
const _hoisted_33 = { class: "nerv-data-label" }
const _hoisted_34 = { class: "nerv-heading nerv-heading-md" }
const _hoisted_35 = { class: "nerv-body-sm" }
const _hoisted_36 = {
  key: 0,
  class: "nerv-caption stack-line"
}
const _hoisted_37 = ["href"]
const _hoisted_38 = { class: "nerv-section" }
const _hoisted_39 = { class: "nerv-section" }
const _hoisted_40 = { class: "nerv-panel nerv-bracket cta" }
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("h2", { class: "nerv-heading nerv-heading-lg" }, "Ship an agent system that survives production"),
  /*#__PURE__*/_createElementVNode("p", { class: "nerv-body" }, " Tell me what you are trying to build and you get an honest read back: whether it is a fit, rough scope, and whether you need me at all. If headcount is the blocker, I can start as a contractor through my own LLC. ")
], -1))
const _hoisted_42 = /*#__PURE__*/_createStaticVNode("<div class=\"proof-strip\" data-v-3a27c7ef><span class=\"nerv-data-label\" data-v-3a27c7ef>Live and public</span><ul data-v-3a27c7ef><li data-v-3a27c7ef><a href=\"https://donatotomato.com\" target=\"_blank\" rel=\"noopener\" data-v-3a27c7ef>donatotomato.com</a></li><li data-v-3a27c7ef><a href=\"https://osrsmarket.net\" target=\"_blank\" rel=\"noopener\" data-v-3a27c7ef>osrsmarket.net</a></li><li data-v-3a27c7ef><a href=\"https://www.npmjs.com/package/claude-rpg\" target=\"_blank\" rel=\"noopener\" data-v-3a27c7ef>npm: claude-rpg</a></li><li data-v-3a27c7ef><a href=\"https://wordpress.org/plugins/search/donatotomato/\" target=\"_blank\" rel=\"noopener\" data-v-3a27c7ef>WordPress.org plugin</a></li><li data-v-3a27c7ef><a href=\"https://github.com/iCodeWebApps\" target=\"_blank\" rel=\"noopener\" data-v-3a27c7ef>github.com/iCodeWebApps</a></li></ul></div>", 1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Logo = _resolveComponent("Logo")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_NervReadout = _resolveComponent("NervReadout")!
  const _component_NervConsole = _resolveComponent("NervConsole")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("section", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createVNode(_component_Logo, { pixelSize: _ctx.heroPixel }, null, 8, ["pixelSize"])
              ]),
              _hoisted_7,
              _hoisted_8,
              _createElementVNode("div", _hoisted_9, [
                _createVNode(_component_router_link, {
                  to: "/contact",
                  class: "nerv-btn"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Send a project brief")
                  ]),
                  _: 1
                }),
                _createVNode(_component_router_link, {
                  to: "/about",
                  class: "nerv-btn nerv-btn-ghost"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Hiring? See the service record")
                  ]),
                  _: 1
                })
              ])
            ]),
            _createElementVNode("aside", _hoisted_10, [
              _hoisted_11,
              _createElementVNode("dl", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.operator, (row) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: row.key,
                    class: "nerv-datarow"
                  }, [
                    _createElementVNode("dt", _hoisted_12, _toDisplayString(row.key), 1),
                    _createElementVNode("dd", _hoisted_13, _toDisplayString(row.value), 1)
                  ]))
                }), 128))
              ]),
              _hoisted_14
            ])
          ]),
          _hoisted_15
        ])
      ]),
      _createElementVNode("div", _hoisted_16, [
        _createVNode(_component_NervReadout, {
          label: "Shipping since",
          value: "2015",
          note: "Production .NET, cloud and applied AI"
        }),
        _createVNode(_component_NervReadout, {
          label: "Platform end users",
          value: "17",
          unit: "M+",
          tone: "cyan",
          note: "Regulated digital banking platform"
        }),
        _createVNode(_component_NervReadout, {
          label: "npm downloads",
          value: "1,900",
          unit: "+",
          tone: "magenta",
          note: "claude-rpg, past 12 months"
        })
      ])
    ]),
    _hoisted_17,
    _createElementVNode("section", _hoisted_18, [
      _hoisted_19,
      _hoisted_20,
      _createElementVNode("div", _hoisted_21, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.services, (s, i) => {
          return (_openBlock(), _createElementBlock("article", {
            key: s.title,
            class: "service"
          }, [
            _createElementVNode("span", _hoisted_22, _toDisplayString(_ctx.pad(i + 1)), 1),
            _createElementVNode("h3", _hoisted_23, _toDisplayString(s.title), 1),
            _createElementVNode("p", _hoisted_24, _toDisplayString(s.description), 1)
          ]))
        }), 128))
      ])
    ]),
    _createElementVNode("section", _hoisted_25, [
      _hoisted_26,
      _hoisted_27,
      _createElementVNode("ul", _hoisted_28, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tools, (tool) => {
          return (_openBlock(), _createElementBlock("li", {
            key: tool,
            class: "chip"
          }, _toDisplayString(tool), 1))
        }), 128))
      ])
    ]),
    _createElementVNode("section", _hoisted_29, [
      _hoisted_30,
      _hoisted_31,
      _createElementVNode("div", _hoisted_32, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.projects, (p, i) => {
          return (_openBlock(), _createElementBlock("article", {
            key: p.title,
            class: "service"
          }, [
            _createElementVNode("span", _hoisted_33, _toDisplayString(p.kind) + " " + _toDisplayString(_ctx.pad(i + 1)), 1),
            _createElementVNode("h3", _hoisted_34, _toDisplayString(p.title), 1),
            _createElementVNode("p", _hoisted_35, _toDisplayString(p.description), 1),
            (p.stack)
              ? (_openBlock(), _createElementBlock("p", _hoisted_36, _toDisplayString(p.stack), 1))
              : _createCommentVNode("", true),
            (p.href)
              ? (_openBlock(), _createElementBlock("a", {
                  key: 1,
                  href: p.href,
                  target: "_blank",
                  rel: "noopener",
                  class: "work-link"
                }, _toDisplayString(p.linkLabel), 9, _hoisted_37))
              : _createCommentVNode("", true)
          ]))
        }), 128))
      ])
    ]),
    _createElementVNode("section", _hoisted_38, [
      _createVNode(_component_NervConsole)
    ]),
    _createElementVNode("section", _hoisted_39, [
      _createElementVNode("div", _hoisted_40, [
        _hoisted_41,
        _createVNode(_component_router_link, {
          to: "/contact",
          class: "nerv-btn"
        }, {
          default: _withCtx(() => [
            _createTextVNode("Send the brief")
          ]),
          _: 1
        })
      ]),
      _hoisted_42
    ])
  ]))
}